module.exports = __webpack_public_path__ + "img/expiring_soon.a7bf1e8f.svg";